import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendCustomerPersona,
  BackendMutationDeleteCustomerPersonaArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation DeleteCustomerPersona($id: ID!) {
    deleteCustomerPersona(id: $id) {
      id
    }
  }
`;

type Variables = BackendMutationDeleteCustomerPersonaArgs;
type Result = Pick<BackendCustomerPersona, 'id'>;

export const deleteCustomerPersona = async (variables: Variables) => {
  const result = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<Result>(result.data);
};
